const regexArray = new RegExp('\\[.*?\\]', 'g');
const regexArrayClear = new RegExp('[\\[|\\]]', 'g');

const variableRecursive = (text, data) => {
  const attrKeyArray = text.split('.');
  const attrKey = attrKeyArray.shift();
  let attr;

  const match = attrKey.match(regexArray);
  if (match) {
    const index = match[0].replace(regexArrayClear, '');
    const attrKeyTreated = attrKey.replace(regexArray, '');

    const arrayData = data[attrKeyTreated];
    if (arrayData) {
      attr = arrayData[index];
    }
  } else {
    attr = data[attrKey];
  }

  if (attr instanceof Object) {
    if (attrKeyArray.length === 0) {
      return attr;
    }
    return variableRecursive(attrKeyArray.join('.'), attr);
  } if (!attr) {
    return undefined;
  }
  return attr;
};

export default variableRecursive;
